<template>
    <div class="w-full flex flex-col">
        <div class="w-full flex flex-row items-center justify-start">
            <div class="flex w-2/3 lg:w-10/12">
                <template v-if="mode == 'edit'">
                <div v-for="field, fieldindex in fields" class="flex flex-col items-start justify-start pr-4">
                    <label v-html="field.label" class="block text-sm text-gray-700 sm:mt-px sm:pt-2"></label>
                    <div v-if="mode == 'edit'">
                        <input v-if="field.valueset == null" v-model="fieldValues[field.field]" type="text"
                               class="block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:max-w-xs sm:text-sm border-gray-300 rounded-md"
                        >
                        <select v-else v-model="fieldValues[field.field]"
                                class="block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:max-w-xs sm:text-sm border-gray-300 rounded-md">
                            <option v-for="valuesetElement in field.valueset"
                                    v-html="valuesetElement.label"
                                    :value="valuesetElement.value"
                            ></option>
                        </select>
                    </div>
                </div>
                </template>
                <template v-if="mode == 'show'">
                    <div v-html="fieldsLabel"></div>
                </template>
            </div>
            <div class="flex w-1/3 lg:w-2/12 items-center" v-if="false">
                <template v-if="mode == 'edit'">
                    <button class="m-1 p-1 bg-customindigo text-indigo-700"  v-on:click="emitMessage('save')" v-html="translate('Save')"></button>
                    <button class="m-1 p-1 bg-gray-300"  v-on:click="emitMessage('cancel')" v-html="translate('Cancel')"></button>
                    <button class="m-1 p-1 bg-red-500 text-white"  v-on:click="emitMessage('delete')" v-html="translate('Delete')"></button>
                </template>
                <template v-if="mode == 'show'">
                    <button class="m-1 p-1 bg-customindigo text-indigo-700"  v-on:click="emitMessage('edit')" v-html="translate('Edit')"></button>
                </template>
            </div>
        </div>
        <div class="w-full" v-if="mode == 'edit' && Object.keys(errors).length > 0">
            <div v-for="error, field in errors" class="pb-1 text-red-500" v-html="error"></div>
        </div>

    </div>

</template>

<script>
    export default {
        inject: ['translate'],
        props: {
            templateString: {type: String},
            fields: {type: Array},
            mode: {type: String},
            subject: {type: String},
            errors: {type: Object, default: () => {return {}}}
        },
        data: function () {
            return {
                fieldValues: {},
            }
        },
        mounted() {
            this.fields.forEach((field) => {
                this.fieldValues[field.field] = field.value;
            });
        },
        methods: {
            emitMessage: function(message) {
                this.$emit(message, {subject: this.subject, data: this.fieldValues});
            },
            getLabelFromValueset: function(field, valueset) {
                let item = valueset.find((valuesetElement) => {
                    return valuesetElement.value == this.fieldValues[field];
                });

                return item == null ? '' : item.label;
            }
        },
        computed: {
            fieldsLabel: function() {
                let result = this.templateString;
                this.fields.forEach((field) => {
                    let replacement = field.valueset === null
                        ? field.value
                        : this.getLabelFromValueset(field.field, field.valueset);
                    result = result.replace(':'+field.field, replacement);
                });
                return result;
            }
        },
        watch: {
            fieldValues: function() {
                this.$emit('input', this.fieldValues);
            },
            fields: function() {
                this.fields.forEach((field) => {
                    this.fieldValues[field.field] = field.value;
                });
            }
        }

    }
</script>
